import $ from 'jquery';
import _ from 'lodash';

export default {
  init() {
  },
  finalize() {
    var subMenu = document.getElementById("page-menu");
    subMenu.style.display = 'flex';
    document.querySelectorAll('#page-content-inner-content h2').forEach(function (h2, idx) {
        var el = document.createElement("li");
        var link = document.createElement("a");
        var text = document.createTextNode(h2.textContent);
        link.appendChild(text);
        link.href = "#h2-" + idx;
        el.appendChild(link);
        subMenu.appendChild(el);
        document.querySelector("ul#page-menu").appendChild(el);
        var anchor = document.createElement('a');
        anchor.id = "h2-" + idx;
        anchor.name = "h2-" + idx;
        anchor.classList.add("anchor");
        h2.appendChild(anchor);
    });

  },
};
